import { SVGProps } from 'react';

const Comeback = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="12"
        height="24"
        viewBox="0 0 12 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        strokeWidth={1.5}
        style={{ strokeLinejoin: 'round', strokeMiterlimit: 2 }}
        {...props}
    >
        <line
            x1={1}
            y1={11.9143}
            x2={10.5}
            y2={2.41431}
            strokeLinecap="round"
        />
        <line
            x1={10.5}
            y1={2.41431}
            x2={10.5}
            y2={22.9143}
            strokeLinecap="round"
        />
        <line
            x1={5}
            y1={11.9143}
            x2={1}
            y2={11.9143}
            strokeLinecap="round"
        />
        <line
            x1={1}
            y1={11.9143}
            x2={1}
            y2={7.91431}
            strokeLinecap="round"
        />
    </svg>
);

export default Comeback;
